// extracted by mini-css-extract-plugin
module.exports = {"techVille":"techVille_techVille__iVT4b","circle":"techVille_circle__Gv2bD","ifFalse":"techVille_ifFalse__GcNl2","ifTrue":"techVille_ifTrue__PSBAV"};